module.exports = __webpack_public_path__ + "img/letter_check.94aa711f.png";